import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  recommendationViewResponse,
  recommendationViewData,
  recommendationViewClear,
} from "../redux/recommendationView/actions";
import PrevArrow from "./LearningPaths/PrevArrow";
import NextArrow from "./LearningPaths/NextArrow";
import SliderCourseListing from "./LearningPaths/SliderCourseListing";
import _, { parseInt } from "lodash";
import { convertHoursToMins, convertTimeFormat } from "../utils/AppUtils";
import { Spinner } from "react-bootstrap";

const RecommendationView = ({ fetchData }) => {
  const dispatch = useDispatch();

  const authBroker = useSelector((state) => state.auth.authBroker);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const recommendationData1 = useSelector(
    (state) => state.recommendationView.recommendationViewData
  );

  // console.log("ooo", recommendationData1);
  const [recommendView, setRecommendView] = useState({});
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    if (!_.isEmpty(authBroker) && fetchData) {
      getViewRecommendedData();
    }
  }, [dispatch, authBroker, fetchData]);

  useEffect(() => {
    // console.log("Recommend", recommendationData1);
    if (!_.isEmpty(recommendationData1)) {
      setIsLoading(false)
      if (recommendationData1.status === "success") {
        const list1 = recommendationData1.payload.payload;
        if (!_.isEmpty(list1)) {
          for (let course of list1) {
            course.is_bundle = false;
            course.is_purchased = course.is_paid;
            course.showBuy = true;
            course.is_free = false;
            if (course.sfdc_product_type.toLowerCase() === "basic") {
              course.showBuy = false;
              course.is_paid = true;
              course.is_free = true;
            } else if (course.sfdc_product_type.toLowerCase() === "premium") {
              if (isPremiumUser) {
                course.showBuy = false;
                course.is_paid = true;
                course.is_free = true;
              } else {
                if (course.product_offer_for_basic) {
                  course.sale_price = 0.0;
                  course.regular_price = 0.0;
                } else {
                  course.sale_price = course.product_basic_price;
                  course.regular_price = course.product_market_price;
                }
              }
            } else if (course.sfdc_product_type.toLowerCase() === "alacarte") {
              if (isPremiumUser) {
                if (course.product_offer_for_premium) {
                  course.sale_price = 0.0;
                  course.regular_price = 0.0;
                } else {
                  course.sale_price = course.product_premium_price;
                }
              } else {
                if (course.product_offer_for_basic) {
                  course.sale_price = 0.0;
                  course.regular_price = 0.0;
                } else {
                  course.sale_price = course.product_basic_price;
                }
              }
              course.regular_price = course.product_market_price;
            } else if (course.sfdc_product_type.toLowerCase() === "bundle") {
              course.is_bundle = true;
            }
            if (course.sfdc_product_type.toLowerCase() !== "bundle") {
              if (course.durationUnit === "Hours") {
                course.duration = convertHoursToMins(course.duration);
              }
              course.duration = convertTimeFormat(course.duration);
              course.durationUnit = "";
            } else {
              // console.log('Duration', course)
              if (!_.isEmpty(course.course_list)) {
                course.is_bundle = true;
                for (let cl of course.course_list) {
                  if (cl.durationUnit === "Hours") {
                    cl.duration = convertHoursToMins(cl.duration);
                  }
                  cl.duration = convertTimeFormat(cl.duration);
                  cl.durationUnit = "";
                }
              }
            }
          }
          list1.sort((a, b) => parseFloat(b.views) - parseFloat(a.views));
          setRecommendView(list1);
        }
      }
      dispatch(recommendationViewClear());
    }
  }, [recommendationData1]);

  //console.log("EMAIL", typeof localStorage.getItem("EMAIL_SESSION"));
  const getViewRecommendedData = () => {
    setIsLoading(true);
    dispatch(
      recommendationViewData({
        module: "myViewRecommendation",
        postData: {
          email: authBroker.payload.user.email,
          user_id: authBroker?.payload?.user?.user_id,
          company_id: authBroker.payload.user.company_id,
          //email:
        },
      })
    );
  };

  return (
    <>
      {
        isLoading ? <div className="container not-found mt-3 mb-3">
          <div className="interboxes">
            <Spinner animation="border" />
          </div>
        </div> :
          recommendView.length > 0 ? (
            <>
          <section className="subscription-course-section">
          <div className="container">
            <div className="row">
              <div className="col-8">
                <div className="subscriptions-row">
                  <h3 className="subs-course-title">
                  Recommended certifications
                  </h3>
                  <span className="subscriptions-subhead">
                  👍🏻 500+ learners have been certified
                  </span>
                </div>
              </div>
              <div className="col-4 text-end">
              <button type="button" className="view-all-btn">View all<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#415385" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
              </div>
            </div>
            <SliderCourseListing
                        isOnboarding={false}
                        coursesList={recommendView}
                        setFavoriteCourse={() => { }}
                        closeModal={"false"}
                        setCloseModal={() => { }}
                        hasDescription={false}
                        pageType="course"
                        showBlankCard={false}
                      />
          </div>
        </section>
             
            </>
          ) : (
            ""
          )}
    </>
  );
};

export default RecommendationView;
